import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Hoc from "../../component/HOC";
import { USER_GUIDE_SECTIONS } from "./userGuideData";
import "./UserGuide.scss";

const UserGuide = () => {
  const [openId, setOpenId] = useState(USER_GUIDE_SECTIONS[0].id);
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return USER_GUIDE_SECTIONS;
    return USER_GUIDE_SECTIONS.filter((section) => {
      const hay = [section.title, ...(section.steps || [])]
        .join(" ")
        .toLowerCase();
      return hay.includes(q);
    });
  }, [query]);

  const openSection = useMemo(
    () =>
      filtered.find((s) => s.id === openId) ||
      filtered[0] ||
      USER_GUIDE_SECTIONS[0],
    [filtered, openId]
  );

  const selectSection = (id) => {
    setOpenId(id);
    requestAnimationFrame(() => {
      document.getElementById(`guide-${id}`)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });
  };

  return (
    <Hoc activeMenu="User Guide">
      <div className="admin-user-guide">
        <header className="admin-user-guide__hero">
          <p className="admin-user-guide__kicker">Admin Portal</p>
          <h1>User Guide</h1>
          <p>
            How to configure Program &amp; Subscriptions, Free Plan, courses,
            emails, Order Labs, and the other Admin features. Search or open a
            topic anytime from the list.
          </p>
          <input
            className="admin-user-guide__search"
            type="search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search topics (membership, courses, emails, labs…)"
            aria-label="Search user guide"
          />
        </header>

        <nav className="admin-user-guide__toc" aria-label="Guide topics">
          {filtered.map((section) => (
            <button
              type="button"
              key={section.id}
              className={
                section.id === openSection.id
                  ? "admin-user-guide__toc-btn is-active"
                  : "admin-user-guide__toc-btn"
              }
              onClick={() => selectSection(section.id)}
            >
              {section.title}
            </button>
          ))}
        </nav>

        {filtered.length === 0 ? (
          <p className="admin-user-guide__empty">
            No topics match “{query}”. Try membership, course, email, or labs.
          </p>
        ) : (
          <Box className="admin-user-guide__panels">
            {filtered.map((section) => (
              <Accordion
                key={section.id}
                id={`guide-${section.id}`}
                expanded={openSection.id === section.id}
                onChange={(_, expanded) =>
                  setOpenId(expanded ? section.id : openSection.id)
                }
                className="admin-user-guide__accordion"
                disableGutters
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <span>{section.title}</span>
                </AccordionSummary>
                <AccordionDetails>
                  {section.path ? (
                    <Button
                      component={Link}
                      to={section.path}
                      className="admin-user-guide__open"
                      variant="contained"
                    >
                      Open this Admin page
                    </Button>
                  ) : null}
                  <ol>
                    {section.steps.map((step) => (
                      <li key={step}>{step}</li>
                    ))}
                  </ol>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        )}

        {filtered.length > 0 ? (
          <p className="admin-user-guide__foot">
            Showing: <strong>{openSection.title}</strong>
          </p>
        ) : null}
      </div>
    </Hoc>
  );
};

export default UserGuide;
